// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"e354a955","220":"b29e9e9e","723":"d56014de","789":"7add0ca4","835":"80632ffb","865":"d3e8ce76"}[chunkId] + ".chunk.css";
};